module.exports = __webpack_public_path__ + "static/media/B1.24677e3b.jpg";